import {c, color, theme, is_mobile} from './modules/settings.js';

(function ($) {
	$(function () {

		const $body = $('body');
		const $trigger = $('#back-top-top');
		const hiddenClass = 'footercontrols__up--hidden';
		$trigger.addClass('footercontrols__up--hidden');
		$trigger.addClass('js-loaded');

		const height = $(document).height();
		const $placeholder = $('.footercontrols-placeholder');
		let controlsOffset = ($placeholder.offset().top + $placeholder.height());

		check_scroll();
		$(window).on('scroll', function () {
			check_scroll();
		});
    
    function onElementHeightChange(elm, callback){
      var lastHeight = elm.clientHeight, newHeight;
      (function run(){
          newHeight = elm.clientHeight;
          if( lastHeight != newHeight )
          callback();
          lastHeight = newHeight;
  
          if( elm.onElementHeightChangeTimer )
              clearTimeout(elm.onElementHeightChangeTimer);
              
          elm.onElementHeightChangeTimer = setTimeout(run, 200);
        })();
  }
  
  
  onElementHeightChange(document.body, function(){
    controlsOffset = ($placeholder.offset().top + $placeholder.height());
    check_scroll();
      // console.log('Body height changed');
  });

		function check_scroll() {
      //console.log('check scroll');
			const scrollTop = $(window).scrollTop();
			const scrollBottom = scrollTop + $(window).height();

			//console.log(`${scrollBottom} >= ${controlsOffset}`);
			if (scrollBottom >= controlsOffset) {
				$body.addClass('footercontrols-relative');
			} else {
				$body.removeClass('footercontrols-relative');
			}

			if (scrollTop >= 100) {
				$trigger.removeClass('footercontrols__up--hidden');
			} else {
				$trigger.addClass('footercontrols__up--hidden');
			}
		}

		$trigger.on('click', function () {
			$("html, body").animate({scrollTop: 0}, "slow");
		});
	});
})(jQuery);